import React from "react";
import {
  Box,
  Typography,
  Grid,
} from "@mui/material";


function SuggestedRoles({
  suggestedRoles = [],
}) {
  return (
    <Box
      className="suggested-roles"
      sx={{
        p: { xs: 2, md: 3 },        
        borderRadius: "39px",
        background: "#F3FBFF",
        height: "100%",
      }}
    >
      {/* <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 1,
          mb: 2,
        }}
      >
        {renderCustomIcon("suggested-roles", 40)}
        <Typography
          variant="h6"
          sx={{
            fontFamily: "poppins",
            fontWeight: 700,
            color: "#000088",
            textAlign: "center",
          }}
        >
          Suggested Roles
        </Typography>
      </Box> */}
      {suggestedRoles.length > 0 ? (
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography variant="body2" sx={{ fontWeight: 600, color: "black" }}>
              Roles
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography
              variant="body2"
              sx={{
                fontWeight: 600,
                textAlign: "right",
                color: "black",
              }}
            >
              Potential Salary Increase
            </Typography>
          </Grid>
          {suggestedRoles.map((item, index) => (
            <React.Fragment key={index}>
              <Grid item xs={6}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <img
                    src="../../assets/images/fire-icon.svg"
                    alt="fire"
                    style={{
                      width: "16px",
                      marginRight: "8px",
                    }}
                  />
                  <Typography variant="body1" sx={{ color: "black" }}>{item.role}</Typography>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Typography
                  variant="body2"
                  sx={{
                    textAlign: "right",
                    fontWeight: 700,
                    color: "black",
                  }}
                >
                  {item.estimatedSalaryIncreasePercent}
                </Typography>
              </Grid>
            </React.Fragment>
          ))}
        </Grid>
      ) : (
        <Typography align="center" sx={{ color: "black" }}>
          No suggested roles found.
        </Typography>
      )}
    </Box>
  );
}

export default SuggestedRoles;
